import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import Helmet from 'react-helmet';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

interface InstagramComponentDataProps {
  html: string;
  dataId?: string;
}

type InstagramComponentProps = InstagramComponentDataProps & MandatoryAdditionalStyle;


const createStyle = () => StyleSheet.create({
  style: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export const InstagramComponent: React.FunctionComponent<InstagramComponentProps> = props => {
  const { html, additionalStyle, dataId } = props;
  const instagramStyle = createStyle();

  React.useEffect(() => {
    // @ts-ignore TS2339
    if (typeof window.instgrm !== 'undefined') {
      // @ts-ignore TS2339
      window.instgrm.Embeds.process();
    }
  }, []);

  return (
    <ErrorBoundary>
      <Helmet>
        <script async src="https://www.instagram.com/embed.js" />
      </Helmet>
      {/* eslint-disable-next-line react/no-danger */}
      <figure data-id={dataId} dangerouslySetInnerHTML={{ __html: html }} className={css(instagramStyle.style, additionalStyle.style)} />
    </ErrorBoundary>
  );
};

export const Instagram = (props: InstagramComponentProps) => <ErrorBoundary><InstagramComponent {...props} /></ErrorBoundary>;
